<template>

  <span>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-tabs :key="isSmallerScreen" :position="isSmallerScreen ? 'top' : 'left'" :value="active_step"
                 class="tabs-shadow-none" id="profile-tabs">



           <vs-tab :label="!isSmallerScreen ? 'RM Live stock' : ''" icon="icon-database" icon-pack="feather" v-if="$canAny(['view-raw-material-stock-inventory'])">
                <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
                    <raw-material-stock-list/>
                </div>
            </vs-tab>

            <vs-tab :label="!isSmallerScreen ? 'RM On hold' : ''" icon="icon-pause" icon-pack="feather" v-if="$canAny(['view-raw-material-waste-inventory'])">
              <raw-material-on-hold-inventories/>
            </vs-tab>

            <vs-tab :label="!isSmallerScreen ? 'RM Waste' : ''" icon="icon-trash-2" icon-pack="feather" v-if="$canAny(['view-raw-material-waste-inventory'])">
                <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
                    <raw-material-waste-list/>
                </div>
            </vs-tab>

            <vs-tab :label="!isSmallerScreen ? 'FG Live stock' : ''" icon="icon-database" icon-pack="feather" v-if="$canAny(['view-product-stock-inventory'])">
                <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
                    <product-stock-list/>
                </div>
            </vs-tab>

            <vs-tab :label="!isSmallerScreen ? 'FG Return stock' : ''" icon="icon-rotate-cw" icon-pack="feather" v-if="$canAny(['view-return-product-inventory'])">
                <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
                    <return-product-stock-list/>
                </div>
            </vs-tab>

          <vs-tab :label="!isSmallerScreen ? 'FG Waste' : ''" icon="icon-trash-2" icon-pack="feather" v-if="$canAny(['view-product-waste-inventory'])">
                <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
                    <product-order-waste-list/>
                </div>
            </vs-tab>

            <vs-tab :label="!isSmallerScreen ? 'Sundry live stock' : ''" icon="icon-database" icon-pack="feather" v-if="$canAny(['view-sundry-item-stock-inventory'])">
                <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
                    <sundry-item-stock-list/>
                </div>
            </vs-tab>
            

            <vs-tab :label="!isSmallerScreen ? 'Sundry Waste' : ''" icon="icon-trash-2" icon-pack="feather" v-if="$canAny(['view-sundry-waste-inventory'])">
                <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
                    <sundry-waste-list/>
                </div>
            </vs-tab>

        </vs-tabs>
      </div>
    </div>
  </span>
</template>

<script>

  import SundryItemStockList from "./SundryItemStockList";
  import ProductStockList from "./ProductStockList";
  import RawMaterialStockList from "./RawMaterialStockList";
  import RawMaterialWasteList from "./RawMaterialWasteList";
  import ProductOrderWasteList from "./ProductOrderWasteList";
  import ReturnProductStockList from "./ReturnProductStockList"
  import SundryWasteList from './SundryWasteList'
  import RawMaterialOnHoldInventories from './RawMaterialOnHoldInventories.vue'

  export default {
    components: {
      SundryItemStockList,
      ProductStockList,
      RawMaterialStockList,
      RawMaterialWasteList,
      ProductOrderWasteList,
      ReturnProductStockList,
      SundryWasteList,
      RawMaterialOnHoldInventories,
    },
    data() {
      return {
        active_step: this.$route.query.step ? this.$route.query.step : '0'
      }
    },
    computed: {
      isSmallerScreen() {
        return this.$store.state.windowWidth < 768
      }
    },
    methods: {}
  }
</script>

<style lang="scss">
  #profile-tabs {
    .vs-tabs--content {
      padding: 0;
    }
  }
</style>
